<fieldset ngModelGroup="login_form">
    <hr class="row outer-b-none"/>
    <div class="row">
        <div class="offset-sm-8 col-sm-40">
            <h3 class="font-weight-300" translate>Form fields</h3>
            <p translate>
                Please use CSS selectors to identify form fields and buttons
            </p>
        </div>

    </div>
    <div class="form-group row" *ngFor="let field of login.form.fields; let $index = index;">
        <label class="col-form-label text-bold text-right col-sm-8"
               [ngbTooltip]="'CSS id or class selector to search for' | translate"
               [triggers]="'focus hover'"
               for="domain_scan_login_form_field_selector{{$index}}"
               translate>
            Input selector*
        </label>
        <div class="col-sm-16">
            <input type="text"
                   class="form-control"
                   id="domain_scan_login_form_field_selector{{$index}}"
                   name="domain_scan_login_form_field_selector{{$index}}"
                   [required]="true"
                   [(ngModel)]="login.form.fields[$index].selector"/>
        </div>
        <label [ngbTooltip]="'Set a default value for selector' | translate"
               [triggers]="'focus hover'"
               class="col-form-label text-bold text-right col-auto"
               for="domain_scan_login_form_field_value{{$index}}"
               translate>
            Default value*
        </label>
        <div class="col">
            <div class="input-group">
                <div class="input-group-prepend">
                    <div class="input-group-text" role="button" (click)="toggleValueVisibility($index)">
                        <span class="fas fa-eye-slash"
                              *ngIf="!loginShowValue[$index]"
                              [ngbTooltip]="'Show' | translate"
                              [attr.aria-label]="'Show text' | translate">
                        </span>
                        <span class="fas fa-eye"
                              *ngIf="loginShowValue[$index]"
                              [ngbTooltip]="'Hide' | translate"
                              [attr.aria-label]="'Hide text' | translate">
                        </span>
                    </div>
                </div>
                <input type="{{loginShowValue[$index] ? 'text': 'password'}}"
                       class="form-control"
                       id="domain_scan_login_form_field_value{{$index}}"
                       name="domain_scan_login_form_field_value{{$index}}"
                       [required]="true"
                       [(ngModel)]="login.form.fields[$index].value">
            </div>
        </div>
        <div class="col-auto text-right">
            <button type="button"
                    [disabled]="login.form.fields.length <= 1"
                    class="btn btn-border-radius btn-secondary"
                    (click)="login.form.fields.length > 1 && removeFormField($index)">
                <span class="sr-only" translate>
                    Remove input selector
                </span>
                <span class="fas fa-trash-alt" aria-hidden="true"></span>
            </button>
        </div>
    </div>
    <div class="row mb-3">
        <div class="offset-sm-8 col-sm-40">
            <button type="button"
                    class="btn btn-border-radius btn-secondary"
                    (click)="addFormField()">
                <span class="fas fa-plus"></span>
            </button>
        </div>
    </div>

    <div class="form-group row">
        <label for="domain_login_form_submit_selector"
               [ngbTooltip]="'CSS selector to find submit button' | translate"
               [triggers]="'focus hover'"
               class="col-form-label text-bold text-right col-sm-8"
               translate>
            Submit selector*
        </label>
        <div class="col-sm-40">
            <input id="domain_login_form_submit_selector"
                   name="domain_login_form_submit_selector"
                   [required]="true"
                   class="form-control"
                   [(ngModel)]="login.form.submit_selector"/>
        </div>
    </div>
    <div class="form-group row">
        <label for="domain_login_verify_location"
               [ngbTooltip]="'URL to redirect to if form is valid' | translate"
               [triggers]="'focus hover'"
               class="col-form-label text-bold text-right col-sm-8"
               translate>
            Verify URL*
        </label>
        <div class="col-sm-40">
            <input id="domain_login_verify_location"
                   name="domain_login_verify_location"
                   class="form-control"
                   [required]="true"
                   validDomain
                   #domainLoginVerifyLocation="ngModel"
                   [(ngModel)]="login.verify.location"/>
        </div>
        <div *ngIf="domainLoginVerifyLocation?.control?.errors?.validDomain && domainLoginVerifyLocation?.control?.dirty"
             class="invalid-feedback block col-sm-40 offset-sm-8" >
            <span *ngIf="domainLoginVerifyLocation?.control?.errors?.validDomain" translate>Is not a valid url</span>
        </div>
    </div>
</fieldset>
